<form [formGroup]="forgotPasswordForm" class="w-100" (submit)="sendRequest()">
  <div class="p-3 mb-3 message-container">
    <fa-icon [icon]="['fas', 'circle-info']" class="mr-1"></fa-icon>
    <span
      i18n="
        AuthPage|Forgot password info message@@forgotPasswordPageInfoMessage"
      >Enter your email address, and a reset password link will be sent to your
      email.</span
    >
  </div>

  <div class="form-group">
    <div class="form-group">
      <fa-icon [icon]="['fas', 'user']" class="input-icon"></fa-icon>
      <input
        type="text"
        class="form-control"
        id="username-input"
        formControlName="username"
        placeholder="Email address"
        i18n-placeholder="
          AuthPage|Username placeholder value@@loginPageUsernamePlaceholder"
      />
    </div>
  </div>

  <button
    type="submit"
    class="btn btn-primary w-100 d-flex align-items-center justify-content-center text-uppercase send-request-btn"
    [disabled]="forgotPasswordForm.invalid"
    i18n="
      AuthPage|Forgot password button value@@forgotPasswordPageSendRequestButton"
  >
    <fa-icon [icon]="['fas', 'paper-plane']" size="xs" class="mr-2"></fa-icon>
    Send Request
  </button>
</form>
